import { NextPage } from 'next';

import { useGroqQuery } from 'hooks/useGroqQuery';
import { ComponentWithFilters, Seo } from '__generated__/graphql';
import { LaunchCalendarPage } from 'ui/pages/LaunchCalendar';
import { LaunchCalendarPageQuery } from 'groq/pages/LaunchCalendarPage';
import { LaunchCalendarItem } from 'ui/components/LaunchCalendar/LaunchCalendarList';

type LaunchCalendarContent = {
  _id: string;
  _type: string;
  seo: Seo;
  aboveContent?: ComponentWithFilters[];
  belowContent?: ComponentWithFilters[];
  products?: LaunchCalendarItem[];
};

declare module 'groq/GroqOperationNames' {
  interface GroqOperationNames {
    LaunchCalendarPage: LaunchCalendarContent;
  }
}

const LaunchCalendar: NextPage = () => {
  const [launchCalendarPage] = useGroqQuery({
    operationName: 'LaunchCalendarPage',
    query: LaunchCalendarPageQuery,
  });

  const page = launchCalendarPage?.data?.content;
  const items = launchCalendarPage?.data?.content?.products;

  return page && items ? (
    <LaunchCalendarPage page={page} items={items} />
  ) : null;
};

export default LaunchCalendar;
